const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLForm = require('app/graphql/Form');

class AssocationForm extends GraphQLForm {

    defaultOptions(){
        var options = {
            'mutationType': 'SubmitRestaurantSupplierAssociation',
            'restaurant': null,
            'supplier': null,
            'onChange': function(){},
        };
        return Object.assign(super.defaultOptions(),options);
    }

    initialize() {
        var self = this;

        this.restaurant = this.settings.restaurant;
        this.supplier = this.settings.supplier;
        this.changed = false;

        this.$form = $('<form/>')
        .addClass('restaurant-supplier-form');

        this.loadData();

        super.initialize();
    }

    hasChange(){
        return this.changed;
    }

    getRestaurant(){
        return this.restaurant;
    }

    getSupplier(){
        return this.supplier;
    }

    getForm(){
        return this.$form;
    }

    loadData(){
        var self = this;

        this.$form
        .html('')
        .append(window.App.generateLoader());

        let queries = [
            this.buildSupplierAssociationQuery(),
            this.buildSupplierQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.fillForm(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildSupplierAssociationQuery(){
        var self = this;

        let parameters = {
            'restaurant': this.restaurant.id,
            'supplier': this.supplier.id,
        };

        let fields = [
            'sendPriceStatus',
            'customerCodes { code }',
            'sectorAssociations { sector { id name } }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurantSupplierAssociation',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }

    buildSupplierQuery(){
        var self = this;

        let parameters = {
            'id': this.supplier.id,
        };

        let fields = [
            'id',
            'name',
            'sectors { id name }',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplier',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }

    createEmptyAssociation(){
        return {
            'sendPriceStatus': true,
            'customerCodes': [],
            'sectorAssociations': []
        }
    }

    fillForm(data){
        this.supplier = data.supplier;
        if(data.restaurantSupplierAssociation){
            this.association = data.restaurantSupplierAssociation;
        }else{
            this.changed = true;
            this.association = this.createEmptyAssociation();
        }

        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-primary')
        .append(window.translate('continue'))
        .append(' ')
        .append(
            $('<i/>')
            .addClass('fa fa-arrow-right')
        );

        this.$form
        .html('')
        .append(this.buildInputs())
        .append(
            $('<div/>')
            .addClass('mt-2 d-flex justify-content-end')
            .append(this.$btnSubmit)
        );

        return this.$form;
    }

    buildInputs(){
        var self = this;    
        let $box = $('<div/>');

        // FIELD sendPriceStatus
        let $sendPriceStatusLabel = $('<label/>')
        .attr('for','sendPriceStatus')
        .addClass('form-check-label')
        .append(window.translate('app.restaurant.show.tabs.supplier.association.sendPriceStatus.label'));
        this.$sendPriceStatusInput = $('<input/>')
        .attr('id','sendPriceStatus')
        .attr('name','sendPriceStatus')
        .attr('type','checkbox')
        .addClass('form-check-input form-check-input-checked-success form-check-input-unchecked-danger')
        .val(1)
        .on("change",function(){
            self.onChange();
        });
        if(this.association.sendPriceStatus && this.association.sendPriceStatus == 1){
            this.$sendPriceStatusInput.prop('checked',true);
        }

        let $sendPriceStatusSwitch = $('<div/>')
        .addClass('form-check form-switch')
        .append(this.$sendPriceStatusInput)
        .append($sendPriceStatusLabel);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($sendPriceStatusSwitch)
        );

        //FIELD customerCodes
        let customerCodesValue = this.getCustomerCodesValue();
        let $customerCodesLabel = $('<label/>')
        .attr('for','customerCodes')
        .append(window.translate('app.restaurant.show.tabs.supplier.association.customerCodes.label'));
        let $customerCodesInput = $('<input/>')
        .attr('type','text')
        .attr('id','customerCodes')
        .attr('name','customerCodes')
        .addClass('form-control')
        .val(customerCodesValue)
        .on("change",function(){
            self.onChange();
        });
        let $customerCodesHelp = $('<small/>')
        .addClass('text-muted')
        .append(window.translate('app.restaurant.show.tabs.supplier.association.customerCodes.help'))
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($customerCodesLabel)
            .append($customerCodesInput)
            .append($customerCodesHelp)
        );

        //FIELD sectorAssociations
        let $sectorAssociationsLabel = $('<label/>')
        .attr('for','sectorAssociations')
        .append(window.translate('app.restaurant.show.tabs.supplier.association.sectorAssociations.label'));
        let $sectorAssociationsSelect = $('<select/>')
        .addClass('form-control')
        .attr('id','sectorAssociations')
        .attr('name','sectorAssociations')
        .on("change",function(){
            self.onChange();
        });

        $sectorAssociationsSelect.append(
            $('<option/>')
            .val('')
            .append(window.translate('app.restaurant.show.tabs.supplier.association.sectorAssociations.empty'))
        );
        for(var i in this.supplier.sectors){
            let sector = this.supplier.sectors[i];
            let $option = $('<option/>')
            .val(sector.id)
            .append(sector.name);
            if(this.hasSector(sector)){
                $option.attr('selected','selected');
            }
            $sectorAssociationsSelect.append($option);
        }
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($sectorAssociationsLabel)
            .append($sectorAssociationsSelect)
        );

        return $box;
    }

    hasSector(sector){
        if(this.association === null){
            return false;
        }
        for(var i in this.association.sectorAssociations){
            let sectorAssociation = this.association.sectorAssociations[i];
            if(sectorAssociation.sector.id == sector.id){
                return true;
            }
        }
        return false;
    }

    getCustomerCodesValue(){
        if(this.association === null){
            return '';
        }
        let codes = [];
        for(var i in this.association.customerCodes){
            let customerCode = this.association.customerCodes[i];
            codes.push(customerCode.code);
        }
        return codes.join('/');
    }

    onDOMReady(){
        super.onDOMReady();
    }

    getFields(){
        let fields = super.getFields();
        return fields;
    }
    
    getVariables(){
        let variables = {};

        variables.restaurant = {
            'value': this.restaurant.id,
            'type': 'Int!'
        };

        variables.supplier = {
            'value': this.supplier.id,
            'type': 'Int!'
        };

        return variables;
    }

    onChange(){
        this.changed = true;
        this.settings.onChange();
    }

    onSuccess(){
        this.changed = false;
        super.onSuccess();
    }


}

module.exports = AssocationForm;

